import { SET_TARGET_KEYS, SET_TARGET_KEYS_FREE_CLASS } from "../constants";

export const setTargetKeys = (payload) => (
    {
        type: SET_TARGET_KEYS,
        payload: payload
    }
);

export const setTargetKeysFreeClass = (payload) => (
    {
        type: SET_TARGET_KEYS_FREE_CLASS,
        payload: payload
    }
);